module.exports = __webpack_public_path__ + "img/platform-event-32.b4819ca0.svg";